import { Route, Routes } from 'react-router';
import './App.css';
import Footer from './components/Footer';
import LandingPage from './components/landing/LandingPage';
import AngelDetails from './components/AngelDetails';
import AboutUs from './components/AboutUs';


function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        {/* <LandingPage /> */}
        <Route path="/angel/:angelName" element={<AngelDetails />} />
        <Route path="/about" element={<AboutUs />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
